import { BranchFormValues } from 'assets/js/pages/engage/workflows/actions/types';
import { CampaignBadges } from 'assets/js/pages/engage/workflows/components/CampaignBadges';
import * as NodeBadges from 'assets/js/pages/engage/workflows/components/NodeBadges';

interface BranchCampaignsDisplayValueProps {
    value: BranchFormValues['value'];
}
const BranchCampaignsDisplayValue = ({ value }: BranchCampaignsDisplayValueProps) => {
    if (!value || 'campaigns' in value === false) return null;
    const { campaigns } = value;

    if (!campaigns || campaigns.length === 0) return null;

    return (
        <NodeBadges.Root>
            <CampaignBadges campaigns={value.campaigns} />
        </NodeBadges.Root>
    );
};

export { BranchCampaignsDisplayValue };
